import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import MaterialTextField from './styled-components/MaterialTextField'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import { Form, FormInputs } from './styled-components/Form'
import ButtonRow from './styled-components/ButtonRow'
import { ButtonPrimary, ButtonSecondaryLink } from './styled-components/Button'
import GDPRCheckboxes from './GDPRCheckboxes'
import MarketingEmailOptInUser from './MarketingEmailOptInUser'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import errorMessages from '../errorMessages'
import ShowHidePasswordButton from './styled-components/ShowHidePasswordButton'
import ForgotPasswordLink from './styled-components/ForgotPasswordLink'
import ForgotPasswordLinkAndLogInButtonContainer from './styled-components/ForgotPasswordLinkAndLogInButtonContainer'
import { AnovaLogoSmall } from './AnovaLogo'
import ToastMessage from './ToastMessage'
import removeIsExistingCognitoUserFromLocalStorage from '../removeIsExistingCognitoUserFromLocalStorage'
import removeIsExistingFirebaseUserFromLocalStorage from '../removeIsExistingFirebaseUserFromLocalStorage'
import { analyticsPage } from '../analytics'

class LogInEmailPasswordForm extends Component {
  state = {
    privacyPolicyChecked: false,
    termsOfServiceChecked: false,
    showPassword: false,
    redirectToPasswordReset: false
  }

  logIn = (event) => {
    event.preventDefault()
    this.props.logIn()
  }

  signUp = (event) => {
    event.preventDefault()
    this.props.signUp()
  }

  handleGDPRPrivacyPolicyCheckboxChange = () => this.setState({ privacyPolicyChecked: !this.state.privacyPolicyChecked })

  handleGDPRTermsOfServiceCheckboxChange = () => this.setState({ termsOfServiceChecked: !this.state.termsOfServiceChecked })

  showOrHidePassword = () => this.setState({ showPassword: !this.state.showPassword })

  forgotPassword = () => this.setState({ redirectToPasswordReset: true })

  shouldDisableNextButton = () => {
    const inputsFilledIn = this.props.email && this.props.password
    const checkboxesChecked = this.state.privacyPolicyChecked && this.state.termsOfServiceChecked

    if (!inputsFilledIn) {
      return true
    } else if (this.props.showGDPROptions && !checkboxesChecked) {
      return true
    }

    return false
  }

  componentDidMount () {
    analyticsPage('ALI Log In - Enter Email And Password Form')

    this.props.logInEmailPasswordFormDidMount()
  }

  componentWillUnmount () {
    removeIsExistingCognitoUserFromLocalStorage()
    removeIsExistingFirebaseUserFromLocalStorage()
  }

  render () {
    const isExistingUser = this.props.isExistingFirebaseUser || this.props.isExistingCognitoUser

    return (
      <Card>
        {this.state.redirectToPasswordReset ? <Redirect to="/password-reset" /> : null}

        {
          this.props.shouldShowEnterPasswordToLinkFacebookToast
            ? <ToastMessage
              messageText={'It looks like you already have an Anova account. For security purposes, please enter your Anova password to link your Facebook account.'}
              dismissToastMessage={this.props.dismissToastMessage} />
            : null
        }

        <div>
          <AnovaLogoSmall />
        </div>

        <Form onSubmit={isExistingUser ? this.logIn : this.signUp} noValidate>
          <HeaderText>
            {
              this.props.isExistingFirebaseUser || this.props.isExistingCognitoUser
                ? <div>Log in</div> : <div>Sign up</div>
            }
          </HeaderText>
          <FormInputs>
            <MaterialTextField
              showErrorText={this.props.emailAlreadyInUse || this.props.invalidEmail || this.props.userNotFound}
              errorMessage={emailInputErrorMessage(this.props)}
              type="email"
              label="Email"
              onChange={event => this.props.handleEmailChangeAndClearEmailErrors(event.target.value)}
              value={this.props.email}
              name="emailInput" />
            <ShowHidePasswordButton
              onClick={this.showOrHidePassword}
              showPassword={this.state.showPassword}
            />
            <MaterialTextField
              showErrorText={this.props.wrongPassword || this.props.weakPassword}
              errorMessage={this.props.wrongPassword ? errorMessages.wrongPassword : errorMessages.weakPassword}
              type={this.state.showPassword ? 'text' : 'password'}
              label="Password"
              autoFocus={true}
              onChange={event => this.props.handlePasswordChangeAndClearPasswordErrors(event.target.value)}
              value={this.props.password}
              name="passwordInput">
            </MaterialTextField>

          </FormInputs>

          {!isExistingUser
              ? <MarketingEmailOptInUser
                  handleMarketingEmailOptInUser={this.props.handleMarketingEmailOptInUser}
                  marketingEmailOptInUser={this.props.marketingEmailOptInUser} />
              : null
          }

          {!isExistingUser && this.props.showGDPROptions
            ? <GDPRCheckboxes
              handleGDPRPrivacyPolicyCheckboxChange={this.handleGDPRPrivacyPolicyCheckboxChange}
              handleGDPRTermsOfServiceCheckboxChange={this.handleGDPRTermsOfServiceCheckboxChange}
              privacyPolicyChecked={this.state.privacyPolicyChecked}
              termsOfServiceChecked={this.state.termsOfServiceChecked} />
            : null
          }

          {
            isExistingUser
              ? <ForgotPasswordLinkAndLogInButtonContainer>
                <ForgotPasswordLink
                  onClick={this.forgotPassword}
                  data-forgot-password-button>
                  Forgot password?
                </ForgotPasswordLink>
                <ButtonPrimary
                  type="submit"
                  disabled={!this.props.email || !this.props.password}
                  data-sign-in-button>
                  LOG IN
                </ButtonPrimary>
              </ForgotPasswordLinkAndLogInButtonContainer>
              : <ButtonRow>
                <ButtonSecondaryLink
                  text="BACK"
                  href="/" />
                <ButtonPrimary
                  type="submit"
                  disabled={this.shouldDisableNextButton()}
                  data-sign-up-button>
                  NEXT
                </ButtonPrimary>
              </ButtonRow>
          }
        </Form>

        <TermsOfServiceAndPrivacyPolicy />
      </Card>
    )
  }
}

const emailInputErrorMessage = (props) => {
  if (props.emailAlreadyInUse) {
    return errorMessages.emailAlreadyInUse
  } else if (props.invalidEmail) {
    return errorMessages.invalidEmail
  } else if (props.userNotFound) {
    return errorMessages.userNotFound
  }
}

export default LogInEmailPasswordForm
